var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "repeat-option-set repeat-option-set--interval-freq" },
    [
      _c("span", { staticClass: "repeat-option-set__label" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.repeatEveryLabel) + "\n\t")
      ]),
      _vm._v(" "),
      !_vm.isIntervalDisabled
        ? _c("input", {
            staticClass: "intervalInput",
            attrs: { type: "number", min: "1", max: "366" },
            domProps: { value: _vm.interval },
            on: { input: _vm.changeInterval }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("RepeatFreqSelect", {
        attrs: { freq: _vm.frequency, count: _vm.interval },
        on: { change: _vm.changeFrequency }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }